import React, { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const ADMIN_PW = process.env.REACT_APP_ASTROLOGER_PASSWORD || 'VTD@2024';

const TrainingAdminPage = () => {
  const [authed,   setAuthed]   = useState(() => sessionStorage.getItem('vtd_admin') === '1');
  const [pw,       setPw]       = useState('');
  const [stats,    setStats]    = useState(null);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [dlLoading,setDlLoading]= useState(false);

  useEffect(() => {
    if (authed) fetchStats();
  }, [authed]);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_BASE}/api/training/stats`);
      if (r.ok) setStats(await r.json());
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  const login = e => {
    e.preventDefault();
    if (pw === ADMIN_PW) { sessionStorage.setItem('vtd_admin','1'); setAuthed(true); }
    else { setError('Wrong password'); setPw(''); }
  };

  const download = async (params = '') => {
    setDlLoading(true);
    try {
      const r    = await fetch(`${API_BASE}/api/training/export${params}`);
      const blob = await r.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href     = url;
      a.download = `vtd-training-export-${Date.now()}.json`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {}
    setDlLoading(false);
  };

  const today = new Date();
  const thisYear  = today.getFullYear();
  const thisMonth = String(today.getMonth() + 1).padStart(2,'0');

  if (!authed) return (
    <div style={{ minHeight:'100vh', background:'#080808', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <form onSubmit={login} style={{ background:'#0e0e0e', border:'1px solid rgba(212,175,55,0.2)', borderRadius:'10px', padding:'2rem', width:'320px' }}>
        <h2 style={{ color:'#D4AF37', fontFamily:'Georgia,serif', marginBottom:'1.5rem', textAlign:'center' }}>Training Admin</h2>
        <input type="password" value={pw} onChange={e=>{setPw(e.target.value);setError('');}}
          placeholder="Password" autoFocus
          style={{ width:'100%', background:'#111', border:'1px solid rgba(212,175,55,0.2)', color:'#E8E0D0', padding:'0.6rem 0.8rem', borderRadius:'5px', outline:'none', boxSizing:'border-box', marginBottom:'0.5rem', fontFamily:'inherit' }} />
        {error && <p style={{ color:'#e05555', fontSize:'0.8rem', margin:'0.3rem 0' }}>{error}</p>}
        <button type="submit" style={{ width:'100%', background:'linear-gradient(135deg,#8B6900,#D4AF37)', color:'#000', border:'none', padding:'0.7rem', borderRadius:'5px', fontWeight:'700', cursor:'pointer', marginTop:'0.5rem' }}>
          Enter →
        </button>
      </form>
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', background:'#080808', color:'#E8E0D0', fontFamily:'system-ui,Arial,sans-serif', padding:'2rem' }}>
      <div style={{ maxWidth:'900px', margin:'0 auto' }}>

        {/* Header */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'2rem', paddingBottom:'1rem', borderBottom:'1px solid rgba(212,175,55,0.2)' }}>
          <div>
            <h1 style={{ color:'#D4AF37', fontFamily:'Georgia,serif', margin:0, fontSize:'1.4rem' }}>VTD Training Data Admin</h1>
            <p style={{ color:'#6a6a5a', margin:'0.3rem 0 0', fontSize:'0.82rem' }}>Session learning & AI training data</p>
          </div>
          <button onClick={()=>{sessionStorage.removeItem('vtd_admin');setAuthed(false);}}
            style={{ background:'transparent', border:'1px solid rgba(212,175,55,0.2)', color:'#7a6a3a', padding:'0.35rem 0.85rem', borderRadius:'4px', cursor:'pointer', fontSize:'0.78rem' }}>
            Logout
          </button>
        </div>

        {loading && <p style={{ color:'#6a6a5a' }}>Loading stats…</p>}
        {error   && <p style={{ color:'#e05555' }}>{error}</p>}

        {stats && (
          <>
            {/* Stats grid */}
            <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'1rem', marginBottom:'2rem' }}>
              {[
                { label:'Total Sessions',    value: stats.totalSessions     },
                { label:'Completed',         value: stats.completedSessions  },
                { label:'Total Predictions', value: stats.totalPredictions   },
                { label:'Overall Accuracy',  value: `${stats.overallAccuracy}%` },
              ].map((s,i) => (
                <div key={i} style={{ background:'#0e0e0e', border:'1px solid rgba(212,175,55,0.14)', borderRadius:'8px', padding:'1.2rem', textAlign:'center' }}>
                  <div style={{ fontSize:'1.6rem', color:'#D4AF37', fontWeight:'700' }}>{s.value}</div>
                  <div style={{ fontSize:'0.72rem', color:'#6a6a5a', marginTop:'0.3rem', textTransform:'uppercase', letterSpacing:'0.08em' }}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* Top patterns */}
            {stats.topPatterns?.length > 0 && (
              <div style={{ background:'#0e0e0e', border:'1px solid rgba(212,175,55,0.14)', borderRadius:'8px', padding:'1.4rem', marginBottom:'2rem' }}>
                <h3 style={{ color:'rgba(212,175,55,0.75)', fontSize:'0.78rem', letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:'1rem' }}>
                  Top Confirmed Patterns
                </h3>
                <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.82rem' }}>
                  <thead>
                    <tr style={{ borderBottom:'1px solid rgba(212,175,55,0.1)' }}>
                      {['Section','Lagna','Maha Dasha','Confirmed','Denied','Accuracy'].map(h => (
                        <th key={h} style={{ color:'rgba(212,175,55,0.5)', fontSize:'0.67rem', letterSpacing:'0.08em', textTransform:'uppercase', padding:'0.3rem 0.5rem', textAlign:'left' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {stats.topPatterns.map((p,i) => (
                      <tr key={i} style={{ borderBottom:'1px solid rgba(255,255,255,0.03)' }}>
                        <td style={{ color:'#D4AF37', padding:'0.28rem 0.5rem' }}>{p.section}</td>
                        <td style={{ color:'#C8C0B0', padding:'0.28rem 0.5rem' }}>{p.lagna || '—'}</td>
                        <td style={{ color:'#C8C0B0', padding:'0.28rem 0.5rem' }}>{p.mahaDasha || '—'}</td>
                        <td style={{ color:'#5aaa5a', padding:'0.28rem 0.5rem' }}>{p.confirmCount}</td>
                        <td style={{ color:'#e05555', padding:'0.28rem 0.5rem' }}>{p.denyCount}</td>
                        <td style={{ padding:'0.28rem 0.5rem' }}>
                          <span style={{ color: p.accuracy>=70?'#5aaa5a':p.accuracy>=50?'#D4AF37':'#e05555', fontWeight:'600' }}>
                            {p.accuracy}%
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Download buttons */}
            <div style={{ display:'flex', gap:'1rem', flexWrap:'wrap' }}>
              <button onClick={() => download()} disabled={dlLoading}
                style={{ background:'linear-gradient(135deg,#8B6900,#D4AF37)', color:'#000', border:'none', padding:'0.75rem 1.5rem', borderRadius:'6px', fontWeight:'700', cursor:'pointer', fontSize:'0.88rem' }}>
                📥 Download All Sessions
              </button>
              <button onClick={() => download(`?year=${thisYear}&month=${thisMonth}`)} disabled={dlLoading}
                style={{ background:'rgba(212,175,55,0.1)', border:'1px solid rgba(212,175,55,0.3)', color:'#D4AF37', padding:'0.75rem 1.5rem', borderRadius:'6px', fontWeight:'600', cursor:'pointer', fontSize:'0.88rem' }}>
                📅 Download This Month
              </button>
              <button onClick={fetchStats} disabled={loading}
                style={{ background:'transparent', border:'1px solid rgba(212,175,55,0.25)', color:'#8a7840', padding:'0.75rem 1.2rem', borderRadius:'6px', cursor:'pointer', fontSize:'0.85rem' }}>
                ↺ Refresh
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TrainingAdminPage;
